import React from 'react';
//import socialmedia_placeholder from '../img/socialmedia_placeholder.png';
import PropertiesList from 'components/PropertiesList';
import { Modal, Button } from 'react-bootstrap';
import DocumentTitle from 'react-document-title';
import InputMask from 'react-input-mask';
import { Helmet } from "react-helmet";
//import { contactMyAgent } from 'actions/agents';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as profileActions from 'actions/profile';
import * as agentsActions from 'actions/agents';
import { getProfilePhoto } from '../containers/AgentOfficePage';
import ReCAPTCHA from "react-google-recaptcha";
import {GetMetaTagsProperties} from '../components/util';

const MetaTagsProperties = GetMetaTagsProperties();
const SITE_KEY = process.env.REACT_APP_GoogleRecaptchaSiteKey;
const recaptchaRef = React.createRef();


class AgentProfile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone:'',
            message:'',
            MemberMlsI: '',
            errorMessage: ''
        }
    }

    componentDidMount() {
        if (!this.props.showHeader) {
            this.props.onShowHideHeader(true);
        }
        if (!this.props.showFooter) {
            this.props.onShowHideFooter(true);
        }

        const {params} = this.props.match;
        if (params.MemberMlsId) {
            this.setState({ memberMlsId: params.MemberMlsId});
            this.getAgent(params.MemberMlsId);
            this.getListings(params.MemberMlsId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.notificationMessage !== nextProps.notificationMessage && nextProps.notificationMessage) {
            this.props.showNotification(
                "success",
                "",
                nextProps.notificationMessage,
                5000
            );
        }
        else if (this.props.errorMessage !== nextProps.errorMessage && nextProps.errorMessage) {
            this.props.showNotification(
                "error",
                "",
                nextProps.errorMessage,
                5000
            );
        }
    }

    getAgent = (memberMlsId) => {
        var self = this;
        var url = window.sessionStorage.getItem("RootAPI") + `agents/agentdetail/${memberMlsId}`;

        fetch(url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
            }
        })
        .then(response => {
            if (response.ok) return response.json()
            else throw Error(response.statusText)
        })
        .then(json => {
            self.setState({ agent: json});
        })
        .catch(function (data) {
            console.log(data);
        });
    }

    getListings = (memberMlsId) => {
        var self = this;
        var url = window.sessionStorage.getItem("RootAPI") + `agents/mylistings/${memberMlsId}`;

        fetch(url,
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
            }
        })
        .then(response => {
            if (response.ok) return response.json()
            else throw Error(response.statusText)
        })
        .then(json => {
            self.setState({ listings: json.Listings, soldListings: json.SoldListings });
        })
        .catch(function (data) {
            console.log(data);
        });
    }

    workWithAgent = () => {
        var self = this;
        const { audience } = this.props;                
        if (audience.type === "client") {        
            if(self.props.showNotification) {
                self.props.showNotification(
                    "success",
                    "",
                    "Are you sure, you want to work with this agent?",
                    5000,
                    "Cancel",
                    null,
                    null,
                    "Yes",
                    self.workWithAgentConfirmed
                );
            }
        }
        else {
            self.props.profileActions.setProfileError('Please register and login first to work with an agent');
            // TODO open register modal
            return;
        }
    }

    workWithAgentConfirmed = () => {
        var self = this;
        const { audience } = this.props;        
        var url = null;
        if (audience.type === "client") {
            url = window.sessionStorage.getItem("RootAPI") + `clients/${audience.Id}/updateworkingwithagent/${this.state.agent.Id}`;
        }
        
        if(url && url !== ""){
            fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
                }
            })
            .then(response => {
                if (response.ok) return response.json();
                else return null;                
            })
            .then(json => {
                if(!json){
                    self.props.profileActions.setProfileSuccess("An error has occurred.");
                }
                else if(json && json.Message && json.Message !== ""){
                    self.props.profileActions.setProfileSuccess(json.Message);
                }
                self.props.profileActions.fetchMyAgentProfile();
            })
            .catch(function (data) {
                self.props.profileActions.setProfileError("An error has occurred.");
                console.log(data);
            });
        }
    }

    handleInputChange = (event) => {
        this.setState({errorMessage: ''});
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit = (e, agent) => {
        const { agentsActions } = this.props;
        if (e) e.preventDefault();
        var errorMessage = '';
        const recaptchaValue = recaptchaRef.current.getValue();

        if (!this.state.name.length)
            errorMessage = "Name is required";
        else if (!this.state.email.length || !(/^[\w-+.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.state.email)))
            errorMessage = "Must enter valid email address"
        else if (!this.state.phone.length || !(/^(?:\D*\d){10}\D*$/.test(this.state.phone)))
            errorMessage = "Phone is required"
        else if (!this.state.message.length)
            errorMessage = "Message is required"
        else if(!recaptchaValue)
            errorMessage = "Oops, you have to check the captcha!"    

        if(errorMessage.length) {
            this.setState({errorMessage});
            return;
        }

        var body = {
            FromName: this.state.name,
            From: this.state.email,
            Phone: this.state.phone,
            Message: this.state.message,
            AgentId: agent.Id,
        };
        if(agent && agent.MemberEmail && agent.MemberEmail !== ""){
            body.To = agent.MemberEmail;
        }
        //If there is default agent then pass default agent id to use default agent specific email template
        if (process.env.REACT_APP_DefaultAgentId !== undefined && 
            process.env.REACT_APP_DefaultAgentId !== null && 
            process.env.REACT_APP_DefaultAgentId !== "")
        {
            body.BrokerAgentId = process.env.REACT_APP_DefaultAgentId;
        }
        //---

        agentsActions.contactMyAgent(body);
        this.setState({ showModal: false, name: '', email: '', phone: '', message: ''});
        recaptchaRef.current.reset();
    }

    showModal = (agent) => {
        return <Modal className="client_mg_popup" show={this.state.showModal} bsSize="small" aria-labelledby="contained-modal-title-lg">
            <Modal.Body>
                <div>
                <h3>Contact { `${agent.MemberFirstName} ${agent.MemberLastName}`}</h3>
                </div>
               <div>
                    <div style={{ marginBottom: '10px' }}>
                        <input className="form-control textbox textbox-large extra_mag" name="name" placeholder="Your Name" onChange={this.handleInputChange} />
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                        <input className="form-control textbox textbox-large extra_mag" name="email" placeholder="Your Email" onChange={this.handleInputChange} />
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                        <InputMask className="form-control textbox textbox-large extra_ma" name="phone"
                            onChange={this.handleInputChange}
                            placeholder="Your Phone"
                            mask="(999) 999-9999" maskChar="_"/>
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                        <textarea rows="4" style={{ padding: "10px 20px"}} className="form-control textbox extra_mag" name="message" placeholder="Your Message" onChange={this.handleInputChange} />
                    </div>
                    <div className="2find_recaptcha">
                        <ReCAPTCHA
                            sitekey={SITE_KEY}
                            ref={recaptchaRef}
                            style={{transform:'scale(0.97)', WebkitTransform:'scale(0.89)', TransformOrigin:'0 0', WebkitTransformOrigin:'0 0'}}
                        />
                    </div>
                    <div style={{ color: 'red', fontWeight: '500'}}>{ this.state.errorMessage }</div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="client_mg_btn">
                    <Button className="" onClick={(e) => this.handleSubmit(e, agent)}>Submit</Button>
                    <Button className="comn_button" onClick={() => this.setState({ showModal: false, errorMessage: '' })} >Cancel</Button>
                </div>
            </Modal.Footer>
        </Modal>            
    }

    copyToClipboard = (cText) => {
        var txt = document.createElement('textarea');
        txt.innerText = cText;
        document.body.appendChild(txt);
        txt.select();
        document.execCommand('copy');
        txt.remove();
    }

    render() {
        const { agent, listings, soldListings, showModal } = this.state;
        const fullName = !agent ? 'Agent/Office Search' : ((agent.MemberFullName && agent.MemberFullName !== "") ? agent.MemberFullName : agent.MemberFirstName + ' ' + agent.MemberLastName);

        var aPurl = "";
        if(this.props.match && this.props.match.params && this.props.match.params.MemberMlsId && this.props.match.params.MemberMlsId !== ""){
            aPurl = `${window.location.protocol}//${window.location.host}/agenturl/${this.props.match.params.MemberMlsId}`;
            if(agent && agent.AgentTlcUrl && agent.AgentTlcUrl !== ""){
                aPurl = agent.AgentTlcUrl;
            }
        }

        const ogTitle = (MetaTagsProperties && MetaTagsProperties.agentProfile && MetaTagsProperties.agentProfile.title) ? MetaTagsProperties.agentProfile.title + fullName : fullName ;
        const ogDesc = (MetaTagsProperties && MetaTagsProperties.agentProfile && MetaTagsProperties.agentProfile.desc) ? MetaTagsProperties.agentProfile.desc : "";
        const ogImage = (MetaTagsProperties && MetaTagsProperties.agentProfile && MetaTagsProperties.agentProfile.img) ? MetaTagsProperties.agentProfile.img : "";
        const ogUrl = window.location.toString().substr(0);

        return <DocumentTitle title={fullName}>
            <React.Fragment>
                <Helmet>
                        <meta name="description" content={ogDesc} />
                        <meta itemProp="name" content={ogTitle} />
                        <meta itemProp="description" content={ogDesc} />
                        <meta itemProp="image" content={ogImage} />
                        <meta property="og:title" content={ogTitle} />
                        <meta property="og:type" content="article" />
                        <meta property="og:url" content={ogUrl} />
                        <meta property="og:image" content={ogImage} />
                        <meta property="og:description" content={ogDesc} />
                </Helmet>
                <div className="fluid row" style={{ fontWeight: "500" }}>
                {agent &&
                    <div className="fluid row">
                        <div>
                            <div className="col-md-2 col-sm-3 col-xs-12 text-center">
                                <div className="agent_pro_photo">
                                    <img src={getProfilePhoto(agent)} alt="" />
                                </div>
                                {/* <img src={socialmedia_placeholder} alt="profile" style={socialStyle} /> */}
                            </div>
                            <div className="col-md-10 col-sm-9 col-xs-12">
                                <div className="mg-top-20 agent_profile_lt flt-left mg-btm-20 full-width margin-top-20">
                                    <div className="col-md-12 col-sm-12 col-xs-12 mb-tru-center">
                                        <h2 className="agentprofile_name">{fullName}</h2>
                                        {/* <button className="btn btn-default" ref="btnSubmit" type="button" >onClick={this.doSearch}> */}
                                        <button className="btn btn-default ask_question_btn mg-top-15 mb-mg-btm-10" ref="btnSubmit" type="button"  onClick={() => this.setState({ showModal: true })}>
                                            <span><i className="fa fa-comment" style={{ paddingRight: "5px" }}></i>Ask a Question</span>
                                        </button>
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 agent_profile_info" id="agentprofilecontent">
                                        <div className="full-width flt-left mg-btm-10">
                                            <span>
                                                <span className="agent_profile_lable"><i className="fa fa-building primary-color profile_icon"></i>Company:</span>
                                                <span className="agent_profile_lable_ct">{agent.OfficeName}</span>
                                            </span>
                                        </div>
                                        <div className="full-width flt-left mg-btm-10">
                                            <span>
                                                <span className="agent_profile_lable"><i className="fa fa-envelope primary-color profile_icon"></i>Email:</span>
                                                <span className="agent_profile_lable_ct"><a href={`mailto:${agent.MemberEmail}`}>{agent.MemberEmail}</a></span>
                                            </span>
                                        </div>                                        
                                        {(agent.AgentUrl && agent.AgentUrl !== "") &&
                                            <div className="full-width flt-left mg-btm-10">
                                                <span>
                                                    <span className="agent_profile_lable">
                                                        <i className="fa fa-desktop primary-color profile_icon"></i>
                                                        <span className="display-ib ver-align-top">Agent Website:</span>
                                                    </span>
                                                    <span className="agent_profile_lable_ct"><a href={"//" + agent.AgentUrl.replace("https://","//").replace("http://","//")} alt="" target="_blank" rel="noopener noreferrer">{agent.AgentUrl}</a></span>
                                                </span>
                                            </div>
                                        } 
                                        {(agent.OfficeUrl && agent.OfficeUrl !== "") &&
                                            <div className="full-width flt-left mg-btm-10">
                                                <span>
                                                    <span className="agent_profile_lable">
                                                        <i className="fa fa-desktop primary-color profile_icon"></i>
                                                        <span className="display-ib ver-align-top">Office Website:</span>
                                                    </span>
                                                    <span className="agent_profile_lable_ct"><a href={"//" + agent.OfficeUrl.replace("https://","//").replace("http://","//")} alt="" target="_blank" rel="noopener noreferrer">{agent.OfficeUrl}</a></span>
                                                </span>
                                            </div>
                                        } 
                                        <div className="full-width flt-left mg-btm-10">
                                            <span>
                                                <span className="agent_profile_lable"><i className="fa fa-phone primary-color profile_icon"></i>Phone:</span>
                                                <span className="agent_profile_lable_ct">
                                                    {(agent.OfficePhone && agent.OfficePhone !== "") ?
                                                        (<a href={"tel:" + agent.OfficePhone.replace(/ /g,"").replace(/-/g,"").replace(/\(/g,"").replace(/\)/g,"")}>
                                                            {agent.OfficePhone}
                                                        </a>) :
                                                    ((agent.MemberPreferredPhone && agent.MemberPreferredPhone !== "") ?
                                                        (<a href={"tel:" + agent.MemberPreferredPhone.replace(/ /g,"").replace(/-/g,"").replace(/\(/g,"").replace(/\)/g,"")}>
                                                            {agent.MemberPreferredPhone}
                                                        </a>) : null
                                                    )}
                                                </span> 
                                            </span>
                                        </div>
                                        <div className="full-width flt-left mg-btm-10">
                                            <span>
                                                <span className="agent_profile_lable">
                                                    <i className="fa fa-mobile primary-color profile_icon ft-sz-25"></i>
                                                    <span className="display-ib ver-align-top">Cell:</span>
                                                </span>
                                                <span className="agent_profile_lable_ct">{agent.MemberMobilePhone && <a href={"tel:" + agent.MemberMobilePhone.replace(/ /g,"").replace(/-/g,"").replace(/\(/g,"").replace(/\)/g,"")}>{agent.MemberMobilePhone}</a>}</span>
                                            </span>
                                        </div>
                                        <div className="full-width flt-left mg-btm-10">
                                            <span>
                                                <span className="agent_profile_lable"><i className="fa fa-id-card primary-color profile_icon"></i>Agent Id:</span>
                                                <span className="agent_profile_lable_ct">{agent.MemberKey}</span>
                                            </span>
                                        </div>
                                        {aPurl &&
                                            <div className="full-width flt-left mg-btm-10">
                                                <span>
                                                    <span className="agent_profile_lable"><i className="fa fa-external-link-square primary-color profile_icon"></i> PURL: </span>
                                                    <span className="agent_profile_lable_ct">
                                                        <a href={aPurl} target="_blank" rel="noopener noreferrer" className="anchor-link">{aPurl}</a>
                                                        {document.queryCommandSupported('copy') && 
                                                        <span>
                                                            <span className="primary-color cursor_pointer mg-lt-10" title="Copy to Clipboard" onClick={() => this.copyToClipboard(aPurl)}>
                                                                <i className="fa fa-clipboard"></i>
                                                            </span>
                                                        </span>
                                                        }
                                                    </span>
                                                </span>
                                            </div>
                                        }
                                        <div className="full-width flt-left mg-btm-10">
                                            <span>
                                                {/* <i className="fa fa-handshake" style={iStyle}></i> */}
                                                <span className="agent_profile_lable"><i className="fa fa-handshake-o primary-color profile_icon"></i></span>
                                                <span className="agent_profile_lable_ct">
                                                    <span className="anchor-link" style={{cursor: 'pointer'}} onClick={this.workWithAgent}>Work with me</span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                {listings && listings.length > 0 &&
                    <div>
                        <div className="current_pro_listing">
                            <header className="main-heading  fluid row">
                                <div className="col-md-12 col-sm-12 col-xs-12 heading-content">
                                    <h2>Current <span className="heading-nomal">Listings</span></h2>
                                    <p>Explore listings by { fullName } and use the <i>Ask a Question</i> button to send a message</p>
                                </div>
                            </header>
                            <div className="fluid row">
                                <PropertiesList
                                    // isFetching={recent.isFetching}
                                    properties={listings}
                                    history={this.props.history}
                                    hideTLC={true} />
                                {/* showNotification={this.props.showNotification} /> */}
                            </div>
                        </div>
                    </div>
                }
                {soldListings && soldListings.length > 0 &&
                    <div>
                        <div className="current_pro_listing">
                            <header className="main-heading  fluid row">
                                <div className="col-md-12 col-sm-12 col-xs-12 heading-content">
                                    <h2>Sold <span className="heading-nomal">Listings</span></h2>
                                </div>
                            </header>
                            <div className="fluid row">
                                <PropertiesList
                                    // isFetching={recent.isFetching}
                                    properties={soldListings.slice(0,12)}
                                    history={this.props.history}
                                    hideTLC={true} />
                                {/* showNotification={this.props.showNotification} /> */}
                            </div>
                        </div>
                    </div>
                }
                {showModal &&
                    this.showModal(agent)
                }
            </div>
            </React.Fragment>
        </DocumentTitle>
    }
}

const mapStateToProps = (state, props) => ({
    audience: state.session.audience,
    notificationMessage: state.profile.notificationMessage,
    errorMessage: state.profile.error
});

const mapDispatchToProps = dispatch => ({
    profileActions: bindActionCreators(profileActions, dispatch),
    agentsActions: bindActionCreators(agentsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentProfile);
